import './List.scss';
import { forwardRef } from 'react';

export const List = forwardRef(({ children, className='', ...rest }, ref) => {
    return (
        <div ref={ref} className={`List ${className}`} {...rest}>
            {children}
        </div>
    );
});